import { createStart } from "@tanstack/react-start";
import { createMiddleware } from "./lib/create-middleware";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Manual CSRF middleware to avoid a circular dependency in the production
// bundle caused by importing createCsrfMiddleware from @tanstack/react-start.
// Mirrors the default TanStack Start CSRF behaviour: only enforce on serverFn
// calls and allow same-origin requests.
const csrfMiddleware = createMiddleware().server(async ({ request, next }) => {
  const handlerType = (request as Request & { handlerType?: string }).handlerType;
  if (handlerType !== "serverFn") return next();

  const secFetchSite = request.headers.get("sec-fetch-site");
  if (secFetchSite === "same-origin" || secFetchSite === "none") return next();

  const origin = request.headers.get("origin");
  if (origin) {
    const requestOrigin = new URL(request.url).origin;
    if (origin === requestOrigin) return next();
  }

  const referer = request.headers.get("referer");
  if (referer) {
    try {
      if (new URL(referer).origin === new URL(request.url).origin) return next();
    } catch {
      // malformed referer
    }
  }

  return new Response("CSRF validation failed", { status: 403 });
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware, csrfMiddleware],
}));
